module.exports = __webpack_public_path__ + "static/media/LogicWheel1_1_4.695e581d.png";